export default class aboveHeader {
    constructor() {
        this.container = document.querySelector('.aboveHeader');
        if (this.container) {
            this.el = this.container.querySelector('.iconSearch');
            this.searchInput = this.container.querySelector('.searchInput');
            this.bindEvents();
        }
    }

    bindEvents() {
        this.el.addEventListener('click', () => this.toggleSearch());
    }

    toggleSearch() {
        this.searchInput.classList.toggle('expanded');
        this.searchInput.focus();
    }
}



// WEBPACK FOOTER //
// ./src/layout/aboveHeader/aboveHeader.js